import { render, staticRenderFns } from "./ExpensesReports.vue?vue&type=template&id=28162d5f"
import script from "./ExpensesReports.vue?vue&type=script&lang=js"
export * from "./ExpensesReports.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports